import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './ThankYou.module.css';

const ThankYou = () => {
  useEffect(() => {
    // Push a custom event to dataLayer to trigger GTM tags securely
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'thank_you_conversion',
        page: window.location.pathname
      });
    }
  }, []);

  return (
    <main className={styles.thankYouPage}>
      <div className="container" style={{ textAlign: 'center', padding: '100px 20px', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div className={styles.iconCircle}>
          <svg viewBox="0 0 512 512" width="60" height="60" fill="currentColor">
            <path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
          </svg>
        </div>
        <h1 className="section-title" style={{ marginTop: '30px', marginBottom: '15px' }}>
          Thank <span className="accent">You!</span>
        </h1>
        <p style={{ fontSize: '18px', color: 'var(--text-body)', maxWidth: '600px', marginBottom: '30px' }}>
          Your enquiry has been successfully submitted. Our aviation career experts will review your details and contact you within 24 hours to guide you on the next steps.
        </p>
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/" className="btn-primary">Back to Home Page</Link>
          <Link to="/courses" className="btn-ghost">Explore More Courses</Link>
        </div>
      </div>
    </main>
  );
};

export default ThankYou;
